// src/theme.ts
// Central design tokens. Values intentionally point at CSS custom properties so
// every existing inline-style consumer follows the global Light/Dark/System
// preference without duplicating page-specific palettes.

export const C = {
  // Backgrounds
  bg:        "var(--color-bg)",
  surface:   "var(--color-surface)",
  surface2:  "var(--color-surface-2)",
  surface3:  "var(--color-surface-3)",
  border:    "var(--color-border)",
  border2:   "var(--color-border-strong)",

  // Primary accent — Georgian cross red
  red:       "var(--color-accent)",
  redDim:    "var(--color-accent-soft)",
  redGlow:   "var(--color-accent-glow)",

  // Secondary accent — modern blue
  blue:      "var(--color-info)",
  blueDim:   "var(--color-info-soft)",

  // Text colors
  text:      "var(--color-text)",
  text2:     "var(--color-text-muted)",
  text3:     "var(--color-text-subtle)",

  // Status colors
  success:   "var(--color-success)",
  successDim:"var(--color-success-soft)",
  successBorder: "var(--color-success-border)",
  warning:   "var(--color-warning)",
  warningDim:"var(--color-warning-soft)",
  warningBorder: "var(--color-warning-border)",

  // Additional semantic tokens used by shared navigation and public surfaces.
  danger:    "var(--color-danger)",
  dangerDim: "var(--color-danger-soft)",
  dangerBorder: "var(--color-danger-border)",
  infoBorder: "var(--color-info-border)",
  onAccent:  "var(--color-on-accent)",
  heroText:  "var(--color-hero-text)",
  heroText2: "var(--color-hero-text-muted)",
  overlay:   "var(--color-overlay)",
  shadow:    "var(--shadow-card)",
} as const;

export const FONT = {
  display: "'Bebas Neue', sans-serif",
  body:    "'Figtree', sans-serif",
} as const;
